var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSeason4S = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 854.36 865.71",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m344.4 429.16c-12.44 51.83 16.11 103.91 64.77 122.16l48.39-201.61c-51.64-5.82-100.72 27.62-113.16 79.45z",
    fill: "#333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m208.14 293.67 105.04 79.96",
    strokeWidth: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358 579.83-76.11 107.87",
    strokeWidth: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.54 484.79-130.56 19.59",
    strokeWidth: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.86 301.27-24.41-129.75",
    strokeWidth: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m464.26 451.96 75.81 269.95",
    strokeWidth: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m660.22 239.33-201.54 220.42",
    strokeWidth: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m732.28 528.1-325.89-83.17",
    strokeWidth: 42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m482.3 534.39 59.59-3.49",
    strokeWidth: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "m532.87 466.75 10.17 63.76",
    strokeWidth: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "m540.5 474.45 29.11-52.11",
    strokeWidth: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "m510.23 394.99 59.23 25.71",
    strokeWidth: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "m518.04 383.81-35.07-48.3",
    strokeWidth: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.42 525.92-49 42.04",
    strokeWidth: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "m554.42 236.01 1.02 114.06",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m670.39 349.27-112.33 3.96",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m610.51 222.94-.93 68.52",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m676.2 294.47-65.42-2.54",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m690.49 430.6-98.61 57.34",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m649.48 587.43-59.05-95.64",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m729.13 478.3-58.72 35.34",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m702.98 571.83-32.33-56.92",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m605.63 638.45-98.17-58.07",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.74 679.22 54.65-98.23",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m582.87 695.46-59.5-34",
    strokeWidth: 23.83
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.48 718.3 33.89-56.01",
    strokeWidth: 23.83
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSeason4S);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Season_4S.9aca90877f5cbcccd34050a431aa5c09.svg";